import { GitCompareIcon } from "lucide-react";
import { MatchGroupsTable } from "@/components/MatchGroupsTable";

export function MatchGroupsPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <div className="mb-6 flex items-center gap-3">
        <GitCompareIcon className="text-muted-foreground size-6" />
        <div>
          <h1 className="text-2xl font-semibold">Match groups</h1>
          <p className="text-muted-foreground text-sm">
            Every three-way match across the platform. Open one to see what the organisation's own reviewer
            sees, with the engine's scores alongside it.
          </p>
        </div>
      </div>

      <MatchGroupsTable />
    </div>
  );
}
